import React, { useEffect, useState } from "react";
import { HandCoins, Megaphone, Users2, Building2, TrendingUp, Gift } from "lucide-react";
import { LeaderboardTable } from "@/components/LeaderboardTable";
import { api, money } from "@/lib/api";

const CARDS = [
  { key: "total_raised", label: "Total raised", icon: HandCoins, accent: "#c97049", fmt: money },
  { key: "campaigns", label: "Campaigns", icon: Megaphone, accent: "#65949c" },
  { key: "teams", label: "Teams", icon: Users2, accent: "#7ba7ad" },
  { key: "supporters", label: "Supporters", icon: Users2, accent: "#87856c" },
  { key: "sponsor_pledged", label: "Sponsor pledged", icon: Building2, accent: "#c99a4e", fmt: money },
  { key: "donations", label: "Gifts logged", icon: Gift, accent: "#00334a" },
];

export default function OverviewTab() {
  const [stats, setStats] = useState(null);
  const [board, setBoard] = useState([]);

  useEffect(() => {
    api.get("/admin/overview").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/leaderboard").then(({ data }) => setBoard(data)).catch(() => {});
  }, []);

  const cellValue = (c) => {
    if (!stats) return "…";
    return c.fmt ? c.fmt(stats[c.key]) : stats[c.key];
  };

  return (
    <div className="space-y-6" data-testid="admin-overview">
      <div>
        <span className="hf-eyebrow">Command center</span>
        <h1 className="mt-1 font-heading text-3xl font-extrabold text-[#00334a]">Overview</h1>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {CARDS.map((c) => (
          <div key={c.key} className="rounded-2xl border border-[#e4d8c4] bg-white p-5">
            <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-[#7c7a6a]">
              <c.icon className="h-4 w-4" style={{ color: c.accent }} /> {c.label}
            </div>
            <div className="mt-2 font-heading text-3xl font-extrabold" style={{ color: c.accent }}>
              {cellValue(c)}
            </div>
          </div>
        ))}
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <div>
          <h2 className="mb-3 font-heading text-lg font-bold text-[#00334a]">Team leaderboard</h2>
          <LeaderboardTable rows={board} />
        </div>
        <div>
          <h2 className="mb-3 flex items-center gap-2 font-heading text-lg font-bold text-[#00334a]">
            <TrendingUp className="h-5 w-5 text-[#65949c]" /> Recent activity
          </h2>
          <div className="space-y-2">
            {stats?.recent_activity?.length ? stats.recent_activity.map((d) => (
              <div key={d.id} className="flex items-center justify-between rounded-xl border border-[#e4d8c4] bg-white px-4 py-3">
                <div>
                  <div className="font-semibold text-[#00334a]">{d.donor_name || "Anonymous gift"}</div>
                  <div className="text-xs capitalize text-[#7c7a6a]">{d.method} · {new Date(d.created_at).toLocaleDateString()}</div>
                </div>
                <div className="font-heading font-extrabold text-[#65949c]">{money(d.amount)}</div>
              </div>
            )) : <div className="rounded-xl border border-dashed border-[#e4d8c4] bg-white p-8 text-center text-[#7c7a6a]">No gifts logged yet.</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
